import { render, staticRenderFns } from "./ApplicantsKorolevView.vue?vue&type=template&id=cf3dfba0&scoped=true&"
import script from "./ApplicantsKorolevView.vue?vue&type=script&lang=js&"
export * from "./ApplicantsKorolevView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3dfba0",
  null
  
)

export default component.exports